
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');
var Template = require('./../../../../skins/newbettingterminal-bet-one.betconstruct.com/terminal/containers/header/template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { Logout } from "../../../actions/login";
import { UIMixin } from "../../../mixins/uiMixin";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSportTypeCount } from "../../../../dev/helpers/asianHelpers/requests";
import { createSelector } from "reselect";
import { HandleLotteryGame } from "../../../helpers/casino/helpers";
import PropTypes from 'prop-types';
import { cashoutedBets, OpenPopup, saveTimer, ticketScan } from "../../../actions/ui";
import Config from "../../../config/main";
import Zergling from "../../../helpers/zergling";
import { getCasinoBetsInfo } from "../../../helpers/tickets";
import { DepositModeEnum } from "../../../constants/enums/depositMode";
import Helpers from "../../../helpers/helperFunctions";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableRefreshButton: false,
      hipayDepositOpened: false
    };
    this.logOut = this.logOut.bind(this);
    this.setHandleClick = this.setHandleClick.bind(this);
    this.openPopupHandler = this.openPopupHandler.bind(this);
    this.refreshButton = this.refreshButton.bind(this);
    this.changePinCode = this.changePinCode.bind(this);
    this.ticketTimerEndOfWork = this.ticketTimerEndOfWork.bind(this);
    this.showLoyalCardPopup = this.showLoyalCardPopup.bind(this);
    this.showCasinoBetHistory = this.showCasinoBetHistory.bind(this);
    this.openCashoutPopup = this.openCashoutPopup.bind(this);
  }
  showLoyalCardPopup() {
    this.props.dispatch(OpenPopup('loyalCardInputPopup'))
  }
  logOut() {
    return () => this.props.dispatch(Logout());
  }
  openCashoutPopup() {
    const balance = sessionStorage.getItem("balance") && JSON.parse(sessionStorage.getItem("balance")).session_balance
    const finalBalance = this.props.userBalance || this.props.terminalBalance || balance || 0
    if (this.props.depositMode === DepositModeEnum.Cash || finalBalance === 0)
      this.props.dispatch(OpenPopup("cashout"))
    else
      this.props.dispatch(OpenPopup("cashoutByBankCard"))
  }
  setHandleClick(type) {
    return () => {
      this.setState({ [type]: !this.state[type] });
    };
  }
  refreshButton() {
    this.setState({ disableRefreshButton: true });
    setTimeout(() => {
      this.setState({ disableRefreshButton: false });
      return window.jsobject.reload();
      // Timer for disabled button is set to 0 default Conifg.refreshButtonDisabledTime
    }, Config.refreshButtonDisabledTime);
  }
  openPopupHandler(id) {
    return () => {
      this.setState({
        iframeUrl: HandleLotteryGame(this.props.user, id)
      });
      setTimeout(() => this.props.dispatch(OpenPopup("iframe", { iframeUrl: this.state.iframeUrl })), 0);

    };
  }

  showCasinoBetHistory() {
    Zergling.get({
      ClientId: this.props.user.profile?.id,
      token: JSON.parse(sessionStorage.getItem("authData")).token
    }, 'terminal_get_casino_bets').then(async data => {
      if (data.HasError) {
        throwTicketError(data.StatusCode);
      } else if (data.Data.length !== 0) {
        const ticketsList = {}
        const dataFromSwarm = data.Data;
        const res = await getCasinoBetsInfo(dataFromSwarm.map(el => Number(el.ExternalId)))

        for (const ticket of dataFromSwarm) {
          const popupData = {
            dataFromSwarm: ticket,
            dataFromCasino: {},
            data: {},
            casinoTicket: true,
            success: true,
            barcode: Number(ticket.ExternalId)
          }

          if (res?.Success) {
            const dataFromCasino = res.Data.find(el => el.CasinoTransactionId === Number(ticket.ExternalId));

            dataFromCasino?.BetMultiplyInfo.forEach((item, index) => {
              const betId = item.TransactionId.split('stage')[0]; // TODO remove someday
              item.win_info = dataFromCasino.WinMultiplyInfo.find(winInfo => {
                const winId = winInfo.TransactionId.split('stage')[0];
                return betId === winId;
              });
            })

            popupData.dataFromCasino = dataFromCasino
          }

          ticketsList[ticket.ExternalId] = popupData
        }

        this.props.dispatch(OpenPopup('multipleTicketsPopup', { ticketsList, onlyList: true }));
      }
    })
  }

  changePinCode() {
    this.props.dispatch(OpenPopup('dmsSetPinCode', { rfid: this.props.user.rfid, loggedIn: true }));
  }

  ticketTimerEndOfWork(second) {
    if (second) return;
    this.props.dispatch(saveTimer(second))
    this.props.dispatch(ticketScan(null, false));
    this.props.dispatch(cashoutedBets(null, false));
  }

  render() {
    return Template.default.apply(this); //eslint-disable-line no-undef
  }
}

const mapStateToProps = (_) => {
  let key = getSwarmDataKeyForRequest(getSportTypeCount("prematch"));
  return createSelector(
    [
      state => state.user && JSON.stringify(state.user),
      state => state.swarmData.data[key],
      state => state.swarmData.loaded[key],
      state => state.terminal.isAdminLoggedIn,
      state => state.uiState.timer,
      state => state.uiState.tickets,
      state => state.user.depositMode,
      state => state.user.profile?.balance,
      state => state.swarmData.data.terminal_balance &&
        Helpers.firstElement(state.swarmData.data.terminal_balance.terminals)?.balance,
      state => state.terminal?.loyalCard?.result
    ],
    (user, count, loaded, isAdminLoggedIn, timer, tickets, depositMode, userBalance, terminalBalance, isLoyalCardConnected) => {
      return {
        user: user && JSON.parse(user),
        count,
        loaded,
        isAdminLoggedIn,
        timer,
        tickets,
        depositMode,
        userBalance,
        terminalBalance,
        isLoyalCardConnected
      };
    });
};

Header.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(mapStateToProps)(SwarmDataMixin({
  Component: UIMixin({ Component: Header }),
  ComponentWillMount: function () {
    this.swarmSubscriptionRequest = getSportTypeCount("prematch");
    this.swarmDataKey = getSwarmDataKeyForRequest(getSportTypeCount("prematch"));
  }
}));
